import { render, staticRenderFns } from "./platjxticketgr.vue?vue&type=template&id=4054e772&"
import script from "./platjxticketgr.vue?vue&type=script&lang=js&"
export * from "./platjxticketgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports